import { __assign, __rest } from "tslib";
// DS: DS4.1
/** A styled radio button control for forms */
import React from 'react';
import c from 'classnames';
import BiInput from '@wix/da-bi/pkg/Components/BiInput';
import s from './RadioButton.scss';
var RadioButton = function (_a) {
    var className = _a.className, inputClassName = _a.inputClassName, children = _a.children, _b = _a.withMargins, withMargins = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, biData = _a.biData, rest = __rest(_a, ["className", "inputClassName", "children", "withMargins", "size", "biData"]);
    return (React.createElement("label", { className: c(s['root'], withMargins && s['with-margins'], children && s['with-children'], s[size], className) },
        React.createElement(BiInput, __assign({ type: "radio", biData: biData, className: inputClassName }, rest)),
        children));
};
RadioButton.displayName = 'RadioButton';
export default RadioButton;
//# sourceMappingURL=RadioButton.js.map